import { fetchWithToken } from '@adsk/acs-sc-web-platform-api';
import { getApiBaseUrl } from '../config';
import { UsersMeResponse } from '../types';
import { CreateSDKConfig } from './types';

const UsersApi = ({ projectId }: CreateSDKConfig) => {
  const API_URL = getApiBaseUrl(projectId);
  return {
    me(): Promise<UsersMeResponse> {
      const url = `${API_URL}/users/me`;
      return fetchWithToken<UsersMeResponse>(url);
    },
    canCreate(): Promise<boolean> {
      return this.me()
        .then((response) => !!response?.permittedActions?.createRfi)
        .catch(() => false);
    },
  };
};

export default UsersApi;
